import React from 'react'
import { useLocation } from 'react-router-dom';
import { BtnHome,ErrBack,ErrTitle,ErrBtnTitle,ErrSubTitle,ErrCode,ErrEsp} from './ErrorElements'

function Error() {
    let location = useLocation();
  return (
    <>  
        <ErrBack>
            <ErrTitle>
                Error 404
            </ErrTitle>
            <ErrSubTitle>
                La URL que ingresaste no existe, da un clic en el botón para regresar al Inicio
            </ErrSubTitle>
            <ErrCode>{location.pathname}</ErrCode>
            <BtnHome to="/"> 
                <ErrBtnTitle>Regresar al Inicio</ErrBtnTitle>          
            </BtnHome>
            <ErrEsp />
        </ErrBack>
    </>
  )
}

export default Error